<div class="p-flight-detail01__time-item p-flight-detail01__time-item--begin">
  <ng-container *ngTemplateOutlet="isEstimateLessThan ? newDateTimeBlock : oldDateTimeBlock"></ng-container>
</div>
<div class="p-flight-detail01__time-item p-flight-detail01__time-item--end">
  <ng-container *ngTemplateOutlet="isEstimateLessThan ? oldDateTimeBlock : newDateTimeBlock"></ng-container>
</div>

<ng-template #oldDateTimeBlock>
  <del
    class="p-flight-detail01__time-stamp"
    [innerHTML]="oldDateTime || '' | dateFormat : 'default_departuredate.time'"
  ></del>
</ng-template>

<ng-template #newDateTimeBlock>
  <span class="p-flight-detail01__time-stamp p-flight-detail01__time-stamp--red" [innerHTML]="estimate"></span>
</ng-template>
